import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { FirestoreService } from 'src/app/services/service.index';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-requestorders',
  templateUrl: './requestorders.component.html',
  styleUrls: ['./requestorders.component.css']
})
export class RequestordersComponent implements OnInit {

  forma: FormGroup;

  displayedColumns: string[] = ['select',  'firstname', 'lastname',  'phone', 'email', 'address',  'distance',  'time', 'total','status', 'actions'];

  dataSource = new MatTableDataSource();
  driversList: any = [];
  user:any;

  dateto:any;
  datefrom:any;
  driver:any;
  selection = new SelectionModel<any>(true, []);

  drivers = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private afs: FirestoreService) { }



  ngAfterViewInit(){
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnInit(): void {

    this.user = this.afs.usersShow;

    this.afs.getAllDriversByCompany(this.user.companyId).subscribe(drivers => {


          this.driversList = drivers;

    });



    this.seeOrders();

  }

  seeOrders(){


    this.afs.getRequestOrderClient().subscribe(orders => {

      this.dataSource.data = orders;

    });
  }

  sortData(sort: Sort) {
    //const data = ELEMENT_DATA.slice();
    if (!sort.active || sort.direction === '') {
      //this.sortedData = data;
      return;
    }
  }

 applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getColorStatus(status){

    if(status == 0){
        return '#e74c3c'
    }else if(status ==1){
       return '#2980b9'
    }else if(status == 2){
       return '#2ecc71'
    }else if(status == 3){
        return '#e74c3c'
     }

}

statusOrder(status){

  if(status == 0)
  {
    return "Pending";
  }
  else if(status == 1)
  {
    return "Assigned";
  }
  else if(status == 2)
  {
    return "Delivered";
  }
  else if(status == 3)
  {
    return "Reject";
  }
}


deleteOrder(order:any){



  Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
  }).then((result) => {
    if (result.value) {
           this.afs
             .deleteRequestOrder(order.id)
             .then((resp: any) => {
               Swal.fire('Good job!', 'Order has been deleted!', 'success');
             })
             .catch((error) => {
               console.log(error);
             });
    }
  });
}


    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
      this.isAllSelected() ?
          this.selection.clear() :
          this.dataSource.data.forEach(row => this.selection.select(row));
    }


    selectDriver(cus){
      console.log(cus.value);
      this.driver = cus.value;
    }

    asignOrderUser(){


      let orders = this.selection.selected;


      orders.forEach(element => {


          element.status = 1;
          element.driverId = this.driver.id;
          element.driverName = this.driver.firstname;
          element.driverLast = this.driver.lastname;
          element.driverImg = this.driver.img;




          this.afs.updateRequestOrder(element.id, element).then(resp => {



            let datefec = new Date(element.datedelivery);
            datefec.setHours(0);
            datefec.setMinutes(0);
            datefec.setMilliseconds(0);
            datefec.setSeconds(0);


            element.datedelivery = datefec.getTime();
            element.orderId = element.id;
            //delete element.id;

            this.afs.createOrderRequest(this.user.companyId,  element.id, element).then(res => {



                Swal.fire(
                  'Good job!',
                  'Create Order ha been registered Successful!!',
                  'success'
                );

               this.selection.clear();

               this.drivers.setValue("");

          }).catch(err => {


              Swal.fire('Oops...', 'Order has not been registered!!', 'error');

          });




          }).catch(err => {

              console.log(err);


            Swal.fire('Oops...', 'Order has not been asigned!!', 'error');


          });


      });



    }


    unsignedAllOrder(){


      let orders = this.selection.selected;

      let cont = 0;

      orders.forEach(element => {

          console.log(element);

          element.driverId = '';
          element.status = 0;

          this.afs.updateRequestOrder(element.id, element).then( order => {


            if(cont == orders.length - 1){

               Swal.fire('Good job!', 'Order unassigned succesful!', 'success');

              this.selection.clear();
            }

            cont++;


          }).catch(err => {


             Swal.fire('Oops...', 'Should select one order!', 'error');

          });

      })



    }

}
